import { useSearchParams } from "react-router-dom";

import _ from "lodash";

import { QSToObject } from "services/common-service";

const useQueryParams = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const params = QSToObject(searchParams);
    const setParams = (newParams: { [key: string]: any }) => {
        setSearchParams(_.pickBy(newParams, _.identity));
    };
    const clearParams = () => {
        setSearchParams({});
    };
    const setByKey = (key: string, value: any) => {
        setSearchParams(_.pickBy({ ...params, [key]: value }, _.identity));
    };
    return { params, setParams, clearParams, setByKey };
};

export default useQueryParams;
